<template>
  <div v-if="showApp">
    <page-statistique></page-statistique>
  </div>
</template>

<script>
import PageStatistique from "@/projects/statistique/components/page-home.vue";

export default {
  data() {
    return {
      showApp: false,
    };
  },
  mounted() {
    let appsToShow = this.$store.state.webApplicationToShow;
    let currentApp = this.$route.fullPath.replace("/", "").split('?')[0];
    if (appsToShow.includes(currentApp)) this.showApp = true;
  },
  components: {
    PageStatistique,
  },
};
</script>

<style>
</style>